import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import MarketplaceStarRating, { LAYOUTS } from '@nerdwallet/react-marketplace-star-rating';
import { TrkElement } from '@nerdwallet/nw-client-lib/trk-helper';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { getMatchScore } from '@nerdwallet/marketplace/selectors/credit-cards';
import { TRK_PRODUCT_LOCATION } from '../lib/constants';
import { buildTrkSectionCategory } from '../lib/utils';
import styles from './keto-product-card.module.less';
import MatchScoreCTA from '../match-score-cta/match-score-cta';

var KetoImageAndRating = function KetoImageAndRating(_ref) {
  var analytics = _ref.analytics,
      className = _ref.className,
      ctaHref = _ref.ctaHref,
      ctaSubtext = _ref.ctaSubtext,
      ctaShowIcon = _ref.ctaShowIcon,
      ctaText = _ref.ctaText,
      displayPage = _ref.displayPage,
      enableAnalytics = _ref.enableAnalytics,
      imageData = _ref.imageData,
      id = _ref.id,
      identity = _ref.identity,
      secondaryCtas = _ref.secondaryCtas,
      marketplaceEntity = _ref.marketplaceEntity,
      omitCta = _ref.omitCta,
      omitRating = _ref.omitRating,
      productType = _ref.productType,
      reviewLinkHref = _ref.reviewLinkHref,
      shouldLogImpression = _ref.shouldLogImpression,
      starRating = _ref.starRating,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkProductPosition = _ref.trkProductPosition,
      trkSectionCategory = _ref.trkSectionCategory,
      productCardImage = _ref.productCardImage,
      showNotYetRated = _ref.showNotYetRated,
      showMatchScoreCTA = _ref.showMatchScoreCTA;
  var impressionContext = useContext(ImpressionContext);
  useDeprecatedPropsWarning({
    component: 'KetoImageAndRating',
    deprecatedProps: [{
      component: 'KetoImageAndRating',
      deprecatedProps: [{
        version: '6.9.0',
        deprecated: 'enableAnalytics',
        migration: 'Use analytics instead.'
      }]
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var marketplaceStarRating = showNotYetRated ? /*#__PURE__*/React.createElement(MarketplaceStarRating, {
    analytics: analytics,
    enableAnalytics: enableAnalytics || !_isEmpty(analytics),
    marketplaceEntity: {},
    showNotYetRated: true,
    trkLocation: TRK_PRODUCT_LOCATION,
    trkPageType: trkPageType,
    className: "".concat(styles.starRatingContainer, " ").concat(styles.noStarRatingWidth)
  }) : /*#__PURE__*/React.createElement(MarketplaceStarRating, {
    analytics: analytics,
    enableAnalytics: enableAnalytics || !_isEmpty(analytics),
    marketplaceEntity: marketplaceEntity,
    layout: LAYOUTS.NUMERIC,
    omitRatingNumberHref: false,
    omitRatingTextHref: true,
    smallRatingText: true,
    className: styles.starRatingContainer,
    productType: productType,
    ratingTextHref: reviewLinkHref,
    starRating: starRating,
    trkLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    trkPageType: trkPageType,
    trkTaxonomy: taxonomy
  });
  var matchScore = getMatchScore(marketplaceEntity);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.ketoImageAndRatingWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.starRating
  }, showMatchScoreCTA && matchScore ? /*#__PURE__*/React.createElement(MatchScoreCTA, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.matchScoreCTAProps,
    identity: identity,
    isKetoCard: true,
    marketplaceEntity: marketplaceEntity,
    taxonomy: taxonomy,
    className: styles.starRatingContainer
  }) : !omitRating && marketplaceStarRating, /*#__PURE__*/React.createElement("div", null, secondaryCtas)), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.imageWrapper, styles.productImage])
  }, _get(imageData, 'src') && (omitCta ? productCardImage : /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-image--").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.productImage,
    marketplaceEntity: marketplaceEntity,
    productLocation: TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    trkElement: TrkElement.image,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productImage'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.LINK // BNK specific props
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardImage))), /*#__PURE__*/React.createElement("div", {
    className: styles.applyNow
  }, /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    annotationText: ctaSubtext,
    className: styles.productLink,
    disableAnnotation: ctaSubtext === false,
    id: id,
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.applyNowButton,
    marketplaceEntity: marketplaceEntity,
    productLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    showIcon: ctaShowIcon,
    text: ctaText,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'cta'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.BUTTON // BNK specific props.
    ,
    displayPage: displayPage
  }))));
};

KetoImageAndRating.propTypes = {
  className: PropTypes.string,
  ctaHref: PropTypes.string,
  ctaSubtext: PropTypes.string,
  ctaShowIcon: PropTypes.bool,
  ctaText: PropTypes.string,
  imageData: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  id: PropTypes.string,
  secondaryCtas: PropTypes.node,
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  omitCta: PropTypes.bool,
  omitRating: PropTypes.bool,
  productType: PropTypes.string,
  reviewLinkHref: PropTypes.string,
  shouldLogImpression: PropTypes.bool,
  starRating: PropTypes.number,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkPageType: PropTypes.string,
  trkProductPosition: PropTypes.number,
  trkSectionCategory: PropTypes.string,
  productCardImage: PropTypes.node,
  showNotYetRated: PropTypes.bool,
  // BNK specific props.
  displayPage: PropTypes.string,
  // analytics
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    matchScoreCTAProps: PropTypes.object // eslint-disable-line react/forbid-prop-types

  }),

  /** @deprecated A flag to indicate if to send analytics */
  enableAnalytics: PropTypes.bool,
  // cc specific props
  identity: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  showMatchScoreCTA: PropTypes.bool
};
KetoImageAndRating.defaultProps = {
  analytics: {},
  omitRating: false,
  displayPage: '',
  // CC specific props
  identity: {},
  showMatchScoreCTA: false
};
export default KetoImageAndRating;